export default {
	DEFAULT: 'default',
	FLOCABULARY: 'flocabulary',
}
